import Vue from 'vue'
import App from './App.vue'
import echarts from 'echarts'
import router from './router'
import store from './store'
import less from 'less'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
/* 导入全局样式表 */
import './assets/css/global.css'

Vue.config.productionTip = false
Vue.use(less)
Vue.use(ElementUI)
Vue.prototype.$echarts = echarts
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
